<div class="projects-page" [attr.dir]="dir">

  <!-- Hero -->
  <header class="page-hero">
    <div class="page-hero__main">
      <button type="button" class="back-btn" [routerLink]="['/strategy']" [attr.aria-label]="dir === 'rtl' ? 'رجوع' : 'Back'">
        @if (dir === 'rtl') {
          <i class="pi pi-angle-right"></i>
        } @else {
          <i class="pi pi-angle-left"></i>
        }
      </button>

      <div class="page-hero__text">
        <h1 class="page-hero__title">{{ 'Initiatives' | navTitle | async }}</h1>
        <p class="page-hero__subtitle">
          {{ strategy?.name || (dir === 'rtl' ? 'عرض المبادرات وتصفيتها حسب الإدارة والحالة.' : 'Browse and filter initiatives by unit and status.') }}
        </p>
      </div>
    </div>

    <a
      class="btn-new-project"
      [routerLink]="['/strategies', strategyId, 'projects', 0]"
      [state]="{ hasAccess: true }">
      <i class="fa-solid fa-plus"></i>
      <span>{{ 'add_new_project' | translate }}</span>
    </a>
  </header>

  <!-- Stats -->
  <section class="stats-grid" aria-label="summary">
    <div class="stat-chip">
      <span class="stat-chip__value">{{ paginator?.total_records || filteredProjects.length || 0 }}</span>
      <span class="stat-chip__label">{{ dir === 'rtl' ? 'الإجمالي' : 'Total' }}</span>
    </div>
    <div class="stat-chip">
      <span class="stat-chip__value">{{ getStatusCount('approved') }}</span>
      <span class="stat-chip__label">{{ dir === 'rtl' ? 'معتمدة' : 'Approved' }}</span>
    </div>
    <div class="stat-chip">
      <span class="stat-chip__value">{{ getStatusCount('pending') + getStatusCount('waiting_for_approval') }}</span>
      <span class="stat-chip__label">{{ dir === 'rtl' ? 'قيد المتابعة' : 'In progress' }}</span>
    </div>
    <div class="stat-chip">
      <span class="stat-chip__value">{{ getStatusCount('draft') }}</span>
      <span class="stat-chip__label">{{ dir === 'rtl' ? 'مسودة' : 'Draft' }}</span>
    </div>
  </section>

  <!-- Filters -->
  <section class="filters-card">
    <div class="filters-grid">
      <div class="filter-field">
        <label class="filter-label">
          <i class="fa-solid fa-building"></i>
          <span>{{ dir === 'rtl' ? 'الإدارة / المكتب' : 'Department / Section' }}</span>
        </label>
        <p-dropdown
          [(ngModel)]="selectedOrgUnitId"
          (onChange)="orgUnitChange()"
          [options]="departmentsAndSections"
          optionLabel="label"
          optionValue="id"
          [filter]="true"
          filterBy="label"
          appendTo="body"
          [placeholder]="dir === 'rtl' ? 'اختر الإدارة أو المكتب' : 'Choose Department or Section'"
          styleClass="modern-dropdown"
          panelStyleClass="filter-dropdown-panel">
          <ng-template pTemplate="item" let-item>
            <div [class.indent-item]="item.indent" class="org-unit-item">
              {{ item.label }}
            </div>
          </ng-template>
        </p-dropdown>
      </div>

      <div class="filter-field">
        <label class="filter-label">
          <i class="fa-solid fa-tasks"></i>
          <span>{{ 'report_initiative_status' | translate }}</span>
        </label>
        <p-dropdown
          [(ngModel)]="selectedProjectStatus"
          (onChange)="selectProjectStatus(selectedProjectStatus)"
          [options]="getFilteredStatusList()"
          optionLabel="label"
          appendTo="body"
          [placeholder]="'select_status' | translate"
          styleClass="modern-dropdown"
          panelStyleClass="filter-dropdown-panel" />
      </div>

      <div class="filter-field">
        <label class="filter-label">
          <i class="fa-solid fa-magnifying-glass"></i>
          <span>{{ 'search' | translate }}</span>
        </label>
        <div class="search-input-wrapper">
          <i class="fa-solid fa-search search-icon"></i>
          <input
            type="search"
            class="modern-search-input"
            (input)="filterBySearch()"
            [(ngModel)]="searchTerm"
            [placeholder]="'search_by_initiative_or_org_unit' | translate" />
          @if (searchTerm) {
            <button type="button" class="search-clear" (click)="clearSearch()" [attr.aria-label]="dir === 'rtl' ? 'مسح' : 'Clear'">
              <i class="fa-solid fa-xmark"></i>
            </button>
          }
        </div>
      </div>
    </div>

    @if (user?.strategy_admin) {
      <div class="scope-buttons" role="group">
        <button
          type="button"
          class="scope-btn"
          [class.active]="projectsScope == 'me'"
          (click)="changeScope('me')">
          <i class="fa-solid fa-user"></i>
          {{ 'My Initiatives' | translate }}
        </button>
        <button
          type="button"
          class="scope-btn"
          [class.active]="projectsScope == 'others'"
          (click)="changeScope('others')">
          <i class="fa-solid fa-users"></i>
          {{ "Everyone's Initiatives" | translate }}
        </button>
      </div>
    }
  </section>

  <!-- Results -->
  <section class="results-card">
    <div class="results-header">
      <h2 class="results-title">
        {{ dir === 'rtl' ? 'قائمة المبادرات' : 'Initiatives list' }}
      </h2>
      <span class="results-count">
        {{ filteredProjects.length }}
        {{ dir === 'rtl' ? 'في هذه الصفحة' : 'on this page' }}
      </span>
    </div>

    @if (isLoading) {
      <div class="loading-state">
        <i class="fa-solid fa-spinner fa-spin"></i>
        <span>{{ dir === 'rtl' ? 'جاري التحميل...' : 'Loading...' }}</span>
      </div>
    } @else if (!filteredProjects.length) {
      <div class="empty-state">
        <div class="empty-state__icon"><i class="fa-solid fa-folder-open"></i></div>
        <p class="empty-state__title">
          {{ dir === 'rtl' ? 'لا توجد مبادرات مطابقة' : 'No matching initiatives' }}
        </p>
        <p class="empty-state__text">
          {{ dir === 'rtl' ? 'عدّل الفلاتر أو أضف مبادرة جديدة.' : 'Adjust filters or add a new initiative.' }}
        </p>
      </div>
    } @else {
      <app-shared-project
        class="full-width"
        [projects]="filteredProjects"
        [isDeleteAllowed]="true"
        [strategyId]="strategyId">
      </app-shared-project>
    }

    @if (paginator.total_records) {
      <div class="paginator-wrap">
        <app-paginator
          [currentPage]="1"
          [totalItems]="paginator.total_records"
          (pageChange)="pageChangeHandler($event)"
          (pageSizeChange)="pageSizeChangeHandler($event)">
        </app-paginator>
      </div>
    }
  </section>

  <p-confirmPopup #confirmPopupRef>
    <ng-template pTemplate="headless" let-message>
      <div class="confirm-box">
        <span>{{ message.message }}</span>
        <div class="confirm-actions">
          <p-button (click)="accept()" [label]="'yes' | translate" severity="danger"></p-button>
          <p-button (click)="reject()" [label]="'no' | translate" severity="secondary"></p-button>
        </div>
      </div>
    </ng-template>
  </p-confirmPopup>
</div>
